export const parseSchedule = (cron) => {
    const split = cron.split(" ");
    if (split.length !== 6) {
        throw new Error(`Invalid cron schedule: ${cron}`);
    }
    const [second, minute, hour, dayOfMonth, month, dayOfWeek] = split;
    return {
        second: parseField(second),
        minute: parseField(minute),
        hour: parseField(hour),
        dayOfMonth: parseField(dayOfMonth),
        month: parseField(month),
        dayOfWeek: parseField(dayOfWeek),
    };
};
const parseField = (field) => {
    if (field === "*") {
        return field;
    }
    const values = field.split(",");
    if (values.length > 1) {
        return values.map(v => parseInt(v, 10));
    }
    return parseInt(field, 10);
};
export const toCron = (schedule) => {
    return [
        toField(schedule.second),
        toField(schedule.minute),
        toField(schedule.hour),
        toField(schedule.dayOfMonth),
        toField(schedule.month),
        toField(schedule.dayOfWeek),
    ].join(" ");
};
const toField = (field) => {
    if (field === "*") {
        return field;
    }
    if (Array.isArray(field)) {
        return field.join(",");
    }
    return field.toString();
};
export const everyMonday = () => {
    return parseSchedule("0 0 10 * * 1");
};
export const firstOfEachMonth = () => {
    return parseSchedule("0 0 10 1 * *");
};
export const defaultRunTime = () => {
    const date = new Date();
    date.setUTCHours(13);
    date.setUTCMinutes(0);
    date.setUTCSeconds(0);
    date.setUTCMilliseconds(0);
    return date;
};
//# sourceMappingURL=schedule.js.map